import React from "react";
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ZAxis,
} from "recharts";
import PropTypes from "prop-types";
import {
  tooltipContentStyle,
  tooltipItemStyle,
  tooltipLabelStyle,
  chartColors,
  defaultGridStyle,
} from "./ChartStyles";
import "./SalesEfficiencyTile.scss";

const SalesEfficiencyTile = ({
  title = "Sales vs Distribution Efficiency",
  subtitle = "By Category",
  data = [],
  xKey = "distribution",
  yKey = "sales",
  sizeKey = "volume",
  nameKey = "name",
}) => {
  return (
    <div
      className="sales-efficiency-tile p-3"
      style={{ width: `100%`, height: `100%` }}
    >
      <h6 className="tile-title mb-2">{title}</h6>
      <p className="tile-subtitle mb-3">{subtitle}</p>

      <ResponsiveContainer width="100%" height="75%">
        <ScatterChart margin={{ top: 10, right: 10, bottom: 10, left: 0 }}>
          <CartesianGrid {...defaultGridStyle} />
          <XAxis
            dataKey={xKey}
            name="Distribution"
            unit="%"
            tick={{ fill: "#6c757d", fontSize: "0.75rem" }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            dataKey={yKey}
            name="Sales"
            unit="k"
            tick={{ fill: "#6c757d", fontSize: "0.75rem" }}
            axisLine={false}
            tickLine={false}
          />
          <ZAxis dataKey={sizeKey} range={[80, 400]} />
          <Tooltip
            cursor={{ strokeDasharray: "3 3" }}
            contentStyle={tooltipContentStyle}
            itemStyle={tooltipItemStyle}
            labelStyle={tooltipLabelStyle}
            formatter={(value, name) =>
              name === "Distribution"
                ? [`${value}%`, name]
                : [`$${value.toLocaleString()}k`, name]
            }
            labelFormatter={(label, payload) =>
              payload?.[0]?.payload?.[nameKey] || ""
            }
          />
          <Scatter
            data={data}
            fill={chartColors.accent}
            stroke={chartColors.accent}
            isAnimationActive={false}
          />
        </ScatterChart>
      </ResponsiveContainer>
    </div>
  );
};

SalesEfficiencyTile.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  data: PropTypes.array.isRequired,
  xKey: PropTypes.string,
  yKey: PropTypes.string,
  sizeKey: PropTypes.string,
  nameKey: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default SalesEfficiencyTile;
